import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_3 = { class: "fw-bolder text-muted" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "# ID", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Name", -1)
const _hoisted_6 = { class: "min-w-100px" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Weight ")
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px text-end" }, "Actions", -1)
const _hoisted_12 = { class: "text-dark fw-bolder d-block fs-6" }
const _hoisted_13 = { class: "text-dark fw-bolder d-block fs-6" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["value", "onChange"]
const _hoisted_16 = {
  key: 1,
  class: "text-dark fw-bolder d-block fs-6"
}
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = {
  class: "btn-group btn-group-sm pb-2 pt-1",
  role: "group"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("th", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("button", {
              disabled: _ctx.isSavingWeights,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitWeights && _ctx.emitWeights(...args))),
              class: "btn btn-sm btn-primary ms-2"
            }, [
              (_ctx.isSavingWeights)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                : _createCommentVNode("", true),
              _hoisted_10
            ], 8, _hoisted_8)
          ]),
          _hoisted_11
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.id
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(item.id), 1)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(item.name), 1)
            ]),
            _createElementVNode("td", null, [
              (_ctx.hasModel && _ctx.$can('can_change_level_weights', 'all'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("input", {
                      type: "number",
                      value: item.weight,
                      class: "form-control w-80px h-30px",
                      onChange: event => (_ctx.model[item.id].weight = event.target.value)
                    }, null, 40, _hoisted_15)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.weight), 1))
            ]),
            _createElementVNode("td", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.emitEditEvent(item)),
                  type: "button",
                  class: "btn btn-sm btn-warning",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#LevelModal"
                }, " Edit ", 8, _hoisted_19),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.openDeleteModal(item)),
                  "data-bs-target": "#deleteModal",
                  "data-bs-toggle": "modal",
                  class: "btn btn-sm btn-danger"
                }, " Delete ", 8, _hoisted_20)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}